import { Application } from '../index'
import axios from 'axios'
function initEvents(container) {
  container.querySelectorAll('.property-pack').forEach(pack => {
    pack.addEventListener('click', () => {
      if (pack.dataset.isCustom) {
        return false
      }
      const id = pack.dataset.packId
      container
        .querySelectorAll('.property-pack.is-active')
        .forEach(activePack => {
          activePack.classList.remove('is-active')
        })
      pack.classList.add('is-active')

      if (id) {
        document.querySelectorAll('button[data-pack-id]').forEach(button => {
          button.disabled = false
          button.dataset.packId = id
        })
      }
    })
  })
}
function renderPackages(container, items) {
  const template = container.querySelector('template')
  if (!template) return false
  items.forEach(item => {
    const itemContainer = template.content.cloneNode(true)
    if (item.custom) {
      itemContainer.querySelectorAll('.property-pack').forEach(node => {
        node.dataset.isCustom = 'true'
        node.style.cursor = 'auto'
      })
      itemContainer.querySelectorAll('[data-custom]').forEach(node => {
        node.style.display = ''
      })
      itemContainer.querySelectorAll('[data-regular]').forEach(node => {
        node.style.display = 'none'
      })
    }
    for (const field in item) {
      const target = itemContainer.querySelector(`[data-field="${field}"]`)
      if (target) {
        target.innerText = item[field]
      } else if (field === 'id') {
        itemContainer.querySelector('[data-pack-id]').dataset.packId =
          item[field]
      }
    }
    container.appendChild(itemContainer)
  })
  Application.lozad()
  initEvents(container)
}
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-packages]').forEach(async parent => {
    const apiUrl = parent.dataset.packages

    try {
      const items = (await axios.get(apiUrl)).data

      if (Array.isArray(items)) {
        renderPackages(parent, items)
      } else if (Array.isArray(items.data)) {
        renderPackages(parent, items.data)
      }
    } catch (e) {
      console.warn(e)
    }
  })
})
